import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
} from "draft-js";
import { Tooltip, Button } from "../../revvComponents";

import NoteAttachments from "./NotesAttachment";
import NotesEditorDraftJS from "./NotesEditorDraftJS";

import "draft-js-mention-plugin/lib/plugin.css";

// Decalarations
const NOTE_TYPE = {
  private: "PRIVATE",
  public: "PUBLIC",
};

class NoteEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      attachments: [],
      draftJSNoteArray: [],
    };

    this.editor = React.createRef();
  }

  componentDidMount() {
    const { content, note } = this.props;
    if (Object.prototype.hasOwnProperty.call(content, "draftJSNote")) {
      this.setState({
        draftJSNoteArray: content.draftJSNote,
        attachments: note.attachments || [],
      });
    } else if (Object.prototype.hasOwnProperty.call(content, "message")) {
      this.setState({
        // message: content.message,
        draftJSNoteArray: [
          convertToRaw(ContentState.createFromText(content.message)),
        ],
        attachments: note.attachments || [],
      });
    }
  }

  _handleNoteObjChange = noteObj => {
    this.setState({ draftJSNoteArray: [noteObj] });
  };

  _saveNote = () => {
    const { note, content, saveNote, noteType, noteThread } = this.props;
    const { message, attachments, draftJSNoteArray } = this.state;
    const mentions = [];
    note.attachments = attachments;
    let newContent;
    if (draftJSNoteArray.length === 0) {
      newContent = { ...content, message };
    } else {
      newContent = { ...content, draftJSNote: draftJSNoteArray };
    }
    const { is_public: isPublicComment } = noteThread;
    let isPublicNote = noteType === NOTE_TYPE.public;
    if (this.props.isSharedDocument) {
      isPublicNote = true;
    } else {
      isPublicNote =
        isPublicComment !== undefined ? isPublicComment : isPublicNote;
    }
    const newNote = {
      ...note,
      content: newContent,
      anchor: note.anchor,
      is_public: isPublicNote,
    };
    if (
      Object.prototype.hasOwnProperty.call(draftJSNoteArray[0], "entityMap")
    ) {
      // Rewrite - this loop can be eliminated if users can be added/removed right when typing in the editor
      Object.values(draftJSNoteArray[0].entityMap).forEach(entity => {
        if (
          entity.type === "mention" &&
          !mentions.includes(entity.data.mention.id)
        ) {
          mentions.push(entity.data.mention.id);
        }
      });
    }
    newNote.mentions = mentions;
    // below code deletes old format of note from content
    // And it should be removed once it is not required anymore
    if (
      Object.prototype.hasOwnProperty.call(newNote.content, "draftJSNote") &&
      Object.prototype.hasOwnProperty.call(newNote.content, "message")
    ) {
      delete newNote.content.message;
    }
    saveNote(newNote);
  };

  _uploadAttachment = e => {
    const { attachments } = this.state;
    const formData = new FormData();
    formData.append("attachment", e.target.files[0]);
    this.props.uploadAttachment(formData).then(response => {
      console.debug(response);
      this.setState({
        attachments: [...attachments, response],
      });
    });
  };

  _updateAttachments = attachments => {
    this.setState({ attachments });
  };

  _removeAttachment = link => {
    const { attachments } = this.state;
    this._updateAttachments(attachments.filter(item => item.Link !== link));
  };

  _checkNoteValidity = () => {
    const { draftJSNoteArray } = this.state;
    if (
      draftJSNoteArray.length === 0 ||
      EditorState.createWithContent(
        convertFromRaw(this.state.draftJSNoteArray[0]),
      )
        .getCurrentContent()
        .getPlainText("\u0001")
        .trim(" ") === ""
    ) {
      return false;
    }
    return true;
  };

  _decideNoteTypeToggle = () => {
    const {
      noteThread: { replies },
      noteType,
      toggleNoteType,
      note,
    } = this.props;
    if (note && !note.id && replies && replies.length === 0) {
      return (
        <div className="noteeditor-notetype-toggle-wrapper">
          <Tooltip
            placement="top"
            overlay="Public notes when you share the link externally"
            align={{
              offset: [0, 2],
            }}>
            <span
              className={`noteeditor-notetype-toggle ${
                noteType === NOTE_TYPE.public ? "active-toggle" : ""
              }`}
              onClick={() => {
                this.editor.current.focus();
                toggleNoteType(NOTE_TYPE.public);
              }}
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              {NOTE_TYPE.public}
            </span>
          </Tooltip>
          <Tooltip
            placement="top"
            overlay="Internal note between you and your team"
            align={{
              offset: [0, 2],
            }}>
            <span
              className={`noteeditor-notetype-toggle ${
                noteType === NOTE_TYPE.private ? "active-toggle" : ""
              }`}
              onClick={() => {
                this.editor.current.focus();
                toggleNoteType(NOTE_TYPE.private);
              }}
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              {NOTE_TYPE.private}
            </span>
          </Tooltip>
        </div>
      );
    }
    return null;
  };

  render() {
    const { attachments, draftJSNoteArray } = this.state;
    const { note, discardNote, isSharedDocument } = this.props;
    const rawValue = draftJSNoteArray.length > 0 ? draftJSNoteArray : null;
    return (
      <div
        data-test="noteseditor-create-note-wrapper"
        className="create-note-wrapper">
        {!isSharedDocument && this._decideNoteTypeToggle()}

        <div
          data-test="noteseditor-note-editor-wrapper"
          className="note-editor-wrapper">
          <NotesEditorDraftJS
            rawValue={rawValue}
            handleNoteObjChange={this._handleNoteObjChange}
            users={this.props.mentionUsers}
            isSharedDocument={isSharedDocument}
            ref={this.editor}
          />
          <NoteAttachments
            attachments={attachments}
            removeAttachment={this._removeAttachment}
          />
          <div className="note-footer create-not-footer">
            {!isSharedDocument && (
              <div className="note-meta">
                <label
                  data-test="noteseditor-custom-file-upload"
                  htmlFor="file-attachment"
                  className="custom-file-upload">
                  <FontAwesomeIcon icon={["far", "paperclip"]} />
                  <input
                    type="file"
                    id="file-attachment"
                    className="note-attachment"
                    onChange={this._uploadAttachment}
                    data-test="noteseditor-file-input"
                  />
                </label>
              </div>
            )}
            <div className="note-actions">
              <Button
                data-test="noteseditor-note-discard-button"
                className="show-inline note-discard-btn btn-transparent"
                onClick={() => discardNote(note)}>
                Discard
              </Button>
              <Button
                data-test="noteseditor-note-save-button"
                className="show-inline note-save-btn"
                onClick={this._saveNote}
                disabled={!(this._checkNoteValidity() || attachments.length)}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { mentionUsers } = state.NotesStore;

  return {
    mentionUsers,
  };
};

export default connect(mapStateToProps, null)(NoteEditor);
